<template>
  <div class="view pa24">
    <el-dialog :title="title" width="800px" :modal-append-to-body="false" :visible.sync="dialogVisible"
               :close-on-click-modal="false" :before-close="closeDialog">
      <el-form :model="ruleForm" ref="dealerRuleForm" label-width="100px" class="ruleForm">
        <el-form-item label="上传文件">
          <el-upload ref="upload" class="upload-demo" :headers="upParams" drag :action="uploadUrl" :auto-upload="false"
                     :on-exceed="handleExceed" :on-error="handleError" :on-success="handleSuccess" :limit="1"
                     accept=".xls,.xlsx" :on-remove="handleRemove">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只能上传xls/xlsx文件。
              <el-button type="text" @click="downloadTemplate">点击下载模板</el-button>
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- 下载模板 -->
        <el-button @click="closeDialog">取 消</el-button>
        <el-button class="btncss" @click="confirmAddDealer" :loading = loading>确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {downDlTemplate, importDl} from '@/api/companyManage.js'
import CommUploadFile from "@/components/CommUploadFile.vue";
import {warning} from "@/api/gps";

export default {
  data() {
    let token = localStorage.getItem("token")
    return {
      fileList: [],
      upParams: {
        token: token
      },
      uploadUrl: '/api/dealer/importDl',
      dialogVisible: false,
      title: '数据导入',
      components: {
        CommUploadFile
      },
      ruleForm: {
        companyId: '',
        file: null
      },
      rules: {},
      fileForm: '',
      loading: false
    };
  },
  onShow() {

  },
  methods: {
    openDialog(type, data, source) {
      this.dialogVisible = true
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles();
      }
    },
    closeDialog() {
      this.dialogVisible = false
      this.$emit('getList')
    },
    downloadTemplate() {
      // const templateUrl = '/file/代理商导入模板 .xlsx'
      // const link = document.createElement('a');
      // link.href = templateUrl;
      // link.download = '代理商导入模板.xlsx';
      // document.body.appendChild(link);
      // link.click();
      // document.body.removeChild(link);

      downDlTemplate().then(result=>{
        console.log('result',result)
        const url = window.URL.createObjectURL(result.data);
        const temp =result.fileName.split(";")[1].split("filename=")[1];
        const fileName = decodeURIComponent(temp)
        const link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        link.setAttribute('download', fileName );
        document.body.appendChild(link);
        link.click();
      })
    },
    // 上传文件
    handleSuccess(response, file, fileList) {
      this.loading = false
      if (response.code != 200) {
        this.$message.error(response.message);
        this.$refs.upload.clearFiles();
      } else {
        var msg = "导入成功";
        if (response.data){
          msg = response.data;
          this.$message({
            dangerouslyUseHTMLString: true,
            message: msg,
            type: 'warning'
          });
          // this.$message.warning(msg);
        }else {
          this.$message.success(msg);
          // this.getList();

        }
        this.closeDialog();

      }
    },
    handleError(err, file, fileList) {
      this.loading = false
      this.$message.error("导入失败")
    },
    handleExceed(files, fileList) {
      if (fileList.length > 1){
        this.loading = false
        this.$message.warning("只能上传1个文件");
      }
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleRemove(file, fileList) {
      this.ruleForm.fileForm = ''; // 清除已保存的文件对象}
    },
    handleFileChange(file, fileList) {
      this.fileList = fileList;  // 更新文件列表
      console.log('文件信息:', file);
    },
    beforeUpload(file) {
      // 允许上传的文件格式列表
      let acceptList = ["xlsx", "xls"]
      // 根据文件名获取文件的后缀名
      let fileType = file.name.split('.').pop().toLowerCase()
      // 判断文件格式是否符合要求
      if (acceptList.indexOf(fileType) === -1) {
        this.$message.error('只能上传 xlsx/xls 格式的文件 !');
        return false
      }
    },
    confirmAddDealer() {
      const uploadFiles = this.$refs.upload.uploadFiles
      if (!uploadFiles || uploadFiles.length === 0) {
        this.$message.warning('请先选择文件')
        return
      }
      this.loading = true
      try {
        this.$refs.upload.submit()
      } catch (e) {
        this.loading = false
        // this.$message.error('提交异常，请重试')
      }
      // const file = this.fileList[0].raw;
      // let formData = new FormData();
      // formData.append('file', file);
      // importDl(formData).then(res => {
      //   if (res.code == 200) {
      //     this.$message({
      //       type: 'success',
      //       message: res.message?res.message:'导入成功'
      //     })
      //     this.closeDialog()
      //   }
      // }).catch(err => {
      //   this.$message.error(err.message)
      // })
    }
  }
};

</script>

<style lang="scss" scoped>
.ml10 {
  margin-left: 10rpx;
}
</style>
